import React, { FC } from 'react';
import styles from './BoardSelectAllWorkspaceMembers.less';
import { OrganizationIcon } from '@trello/nachos/icons/organization';
import { useFeatureFlag } from '@trello/feature-flag-client';
import { forTemplate } from '@trello/i18n';
const format = forTemplate('board_menu_invite_team');

interface Props {
  memberCount: number;
  onClick: () => void;
}

/**
 * A button that renders when memberCount >= 2 and fires onClick when clicked
 */
export const BoardSelectAllWorkspaceMembers: FC<Props> = ({
  onClick,
  memberCount,
}) => {
  const mochaWebBetterMemberSearchEnabled = useFeatureFlag(
    'mocha.web-better-member-search',
    false,
  );
  if (memberCount <= 1) {
    return null;
  }
  return (
    // onMouseDown is used because MemberMultiSelectAutocompleteComponent closes on click
    <div role="button" onMouseDown={onClick} className={styles.inviteWorkspace}>
      <OrganizationIcon
        size="large"
        color="dark"
        dangerous_className={styles.orgIcon}
      />
      <div className={styles.inviteTeamText}>
        {format(
          mochaWebBetterMemberSearchEnabled
            ? 'select-all-x-workspace-members'
            : 'add-all-x-team-members',
          {
            memberCount,
          },
        )}
      </div>
    </div>
  );
};
